import { Switch } from '@mui/material';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MutateOptions, useQueryClient } from 'react-query';

import { QueryKey } from 'enums';
import { TranslationNamespace } from 'i18n';
import { TradeMethod } from 'types';

type Props = {
  tradeMethod: TradeMethod;
  updateStatus: (
    id: string,
    enabled: boolean,
    options: MutateOptions<any, any, any, any>,
  ) => void;
};

export const TradeMethodStatusInfo: React.FC<Props> = ({
  tradeMethod,
  updateStatus,
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.trade_methods',
  });
  const queryClient = useQueryClient();

  const [enabled, setEnabled] = useState(tradeMethod.enabled);

  const toggle = useCallback(
    () =>
      updateStatus(tradeMethod.id, !enabled, {
        onSuccess: () => {
          setEnabled(!enabled);
          queryClient.invalidateQueries(QueryKey.TradeMethods);
          queryClient.invalidateQueries(QueryKey.TradeMethodsNotArchive);
        },
      }),
    [updateStatus, tradeMethod.id, enabled, queryClient],
  );

  useEffect(() => {
    setEnabled(tradeMethod.enabled);
  }, [tradeMethod.enabled]);

  return (
    <Fragment>
      <Switch
        title={enabled ? t('actions.deactivate') : t('actions.activate')}
        checked={enabled}
        onChange={toggle}
      />
    </Fragment>
  );
};
